/**
 * Created by Daniela on 12/09/2016.
 */
export class MaterialEspecificacao {
    ativo: boolean;
    dataCriacao: Date;
    dataUltimaAlteracao: Date;
    descricao: string;
    especificacao: string;
    id: number;
    material_id: number;
    usuario_criacao_id: number;
    usuario_ultima_alteracao_id: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-especificacao/shared/material-especificacao.model.ts
 **/